module.exports = __webpack_public_path__ + "img/pines.c42a9993.svg";